import React, {lazy} from 'react';
import PropTypes from 'prop-types';

const DefaultAuthContainer = lazy(() =>
    import(/* webpackChunkName: "authDefault" */ './DefaultAuthContainer')
);

export default function LazyDefaultAuthContainer({children}) {
    return <DefaultAuthContainer>{children}</DefaultAuthContainer>;
}

LazyDefaultAuthContainer.propTypes = {
    children: PropTypes.node,
};
